import gsap from "gsap";

export default function Contentfullscreenblock() {
  Alpine.data("contentfullscreenblock", () => ({
    init() {
      if (!this.$refs.media) return;

      gsap.fromTo(
        this.$refs.media,
        { yPercent: -15 },
        {
          yPercent: 15,
          ease: "none",
          scrollTrigger: {
            trigger: this.$el,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        },
      );
    },
  }));
}
